import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ViewerService {

  path = environment.apiUrl

  constructor(private http: HttpClient) { }

  Get_viewerAll(pathhh: string): Observable<any> {
    let URL = this.path + 'api/Users/GetVisiter_system/' + pathhh;
 
    return this.http.get(URL);
  }

  Get_viewer_Coop(pathhh: string): Observable<any> {
    let URL = this.path + 'api/Users/GetVisiter_coop/' + pathhh;

    return this.http.get(URL);
  }

  create_viewer_Coop(pathhh: string): Observable<any> {
    let URL = this.path + 'api/Users/AddVisiter_coop/';
    let body = {
      coopId: pathhh,
      count: 1
    }
 
    return this.http.post(URL, body);
  }

  Update_viewerCount(id: string,  count: number): Observable<any> {
    let URL = this.path + 'api/Users/UpdateVisiter_system/' + id;

    return this.http.get(URL);
  }

  Update_viewerCount_Coop(coop_id: string): Observable<any> {
    let URL = this.path + 'api/Users/UpdateVisiterCoop/' + coop_id;

    return this.http.get(URL);
  }

}
